import { useStateSelector } from 'shared/store';
import { notificationsApi } from './api';
import { CreateNotificationDto } from '@sr/dto';
import { useSnack } from 'shared/ui/snack';

export const useManagerNotificationsWs = () => {
  const { user } = useStateSelector((store) => store.auth);
  const { showError } = useSnack();
  if (!user) {
    showError('Пользователь не найден');
    return { isLoading: false, items: [], readAll: async () => {} };
  }
  const readAll = async () => markReadedAll(user.id).unwrap();
  const [markReadedAll] = notificationsApi.useMarkReadedAllMutation();
  const { isLoading, data } = notificationsApi.useGetManagerNotificationsQuery(user.id);
  return { isLoading, items: data?.items ?? [], count: data?.count ?? 0, readAll };
};

export const useNotifications = (filter: string = '') => {
  const { user } = useStateSelector((store) => store.auth);
  const { showError } = useSnack();
  if (!user) {
    showError('Пользователь не найден');
    throw new Error('Пользователь не найден');
  }
  const { data, isLoading } = notificationsApi.useGetNotificationsQuery({ managerId: user.id, filter });

  return { items: data?.items ?? [], isLoading, totalItemsCount: data?.totalItemsCount ?? 0 };
};

export const useAddNotification = () => {
  const [create] = notificationsApi.useAddNotificationMutation();

  const addNotification = (dto: CreateNotificationDto) => create(dto).unwrap();

  return { addNotification };
};
